import React, { useState, useEffect } from 'react'
import { useHistory, Link, useParams} from 'react-router-dom'
import { connect } from 'react-redux'
import { Switch, Space, Pagination, Tooltip, Spin, Skeleton } from 'antd'
import ReactTable from "react-table";
import "react-table/react-table.css";
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { Input } from 'reactstrap'
import { OutlinedButton, FilledBrightButton } from '@oneblinktech-org/helios-base'
import {
    getUserTypes,
    getUserRoles,
    resetUserPassword,
    updateUserInOrg
} from '../../store/user/actions'
import $ from 'jquery';
import { displayShortName } from '../../helpers/globals';
import { plus } from '../../fakeData/svgFiles';
import AutoSelectOnTab from '../AutoSelectOnTab';
import Can from "../../components/Can";
import { PERMISSIONS } from "../../constants/permissions";

const DEFAULT_PAGE_SIZE = 20

const customStyles = {
    headCells: {
        style: {
            paddingLeft: '2px',
            paddingRight: '2px',
        },
    },
    cells: {
        style: {
            paddingLeft: '2px',
            paddingRight: '2px',
        },
    },
}

const columns = [
    {
        Header: "Name",
        id: "lastName",
        accessor: row =>
            <div className="d-flex flex-row align-items-center">
                <div className='text-uppercase user_avatar'>
                    {displayShortName(row)}
                </div>
                <span className={(!row.is_active ? 'inactive' : '') + ' name'}>{row.firstname + ' ' + row.lastname}</span>
            </div>
    },
    {
        Header: "Email",
        id: "email",
        accessor: row => <span className={(!row.is_active ? 'inactive' : '') + 'user-text' }>{row.email}</span>
    },
    {
        Header: "Role",
        id: "userType",
        accessor: row => <span className={(!row.is_active ? 'inactive' : '') + 'user-text'}>{row.role ? row?.role === 'Subordinate' ? 'Office Admin' : row.role : ''}</span>
    },
    {
        Header: "Status",
        id: "is_active",
        accessor: row =>
        <div className="d-flex flex-row align-items-center">
            <div className={(row.is_active ? 'user_active' : 'user_inactive') + " job_status"} ></div>
            <span className={(!row.is_active ? 'inactive' : '') + ' ml-2 user-text'}>{row.is_active ? 'Active' : 'Inactive'}</span>
        </div>
    },
    {
        Header: "Action",
        id: 'action',
        accessor: d => <Tooltip placement="bottomLeft" title="Edit"><img className="pointer" name="edit-action" alt="Edit" src={require("../../assets/images/pencil.svg").default} /></Tooltip>
    },
]

const ExpandableTable = (props) => {
    const history = useHistory()

    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [aUserExpanded, setAUserExpanded] = useState({})
    const [inactiveUser, setInactiveUser] = useState(false)
    const [users, setUsers] = useState([])

    useEffect(() => {
        props.getUserTypes()
    }, [])

    useEffect(() => {
        props.getUserRoles()
    }, [])

    useEffect(() => {
        if (props.data.length > 0) {
            const data = props.data.filter(i => i.role !== 'Customer')
            if (inactiveUser) {
                setData(data.filter(item => !item.is_active))
                setUsers(data.filter(item => !item.is_active))
            }
            else {
                setData(data.filter(item => item.is_active))
                setUsers(data.filter(item => item.is_active))
            }
        }
    }, [props.data])

    useEffect(() => {
        const updateRecord = async () => {
            if (props.isSuccessOrgUserUpdate) {
                const temp = data
                await temp.map(item => {
                    if (item.id === props.updatedUser.id) {
                        return props.updatedUser
                    } else
                        return item
                })
                if (inactiveUser) {
                    $(`#rowId_${props.updatedUser.id}`).fadeOut("slow", async function () {
                        setAUserExpanded({})
                        setData(temp.filter(item => !item.is_active))
                    })
                } else {
                    $(`#rowId_${props.updatedUser.id}`).fadeOut("slow", async function () {
                        setAUserExpanded({})
                        setData(temp.filter(item => item.is_active))
                    });
                }

                props.SetUsersInOrg((prev) => ([...prev?.map((i) => i.id === props.updatedUser.id ? props.updatedUser : i)]))
            } else if (props.isSuccessOrgUserUpdate === false) {
                const users = await props.data.filter(i => i.role !== 'Customer')
                if (inactiveUser) {
                    setData(users.filter(item => !item.is_active))
                    setUsers(users.filter(item => !item.is_active))
                }
                else {
                    setData(users.filter(item => item.is_active))
                    setUsers(users.filter(item => item.is_active))
                }
                props.SetUsersInOrg((prev) => ([...prev?.map((i) => i.id === props.updatedUser.id ? props.updatedUser : i)]))
            }
        }
        updateRecord()
    }, [props.isSuccessOrgUserUpdate, props.updatedUser])

    const onTableChange = (pagination, filters, sorter, extra) => {

    }
    const onPagiChange = (pageNum) => {
        setCurrentPage(pageNum)
        props.getData(pageNum - 1)
    }

    const onSwitch = async (checked) => {
        setInactiveUser(checked)

        if (checked) {
            let copyData = await props.data.filter(item => item.is_active === false)
            setData(copyData)
        } else {
            let copyData = await props.data.filter(item => item.is_active === true)
            setData(copyData)
        }
    }

    const onUserActive = (checked, row) => {
        if (window.confirm("Are you sure?")) {
            setData((prev) => ([...prev?.map((i) => i.id === row.id ? { ...row, is_active: checked } : i)]))
            props.updateUserInOrg({ ...row, is_active: checked })
        }
    }

    const handleNewUser = (e) => {
        props.setNewUser({
            ...props.newUser,
            [e.target.name]: e.target.value
        })
    }

    const roleOptions = Object.entries(props.roles || {}).map(([key, role]) => ({
        key,
        label: role.name,
        value: Number(role.id),
    }));

    return (
        <div>
            <div className="d-flex flex-column flex-md-row justify-content-end align-items-center mb-4">
                <div className="d-flex flex-row align-items-center col-12 col-xl-5">
                    <label className="table-toggle-text my-0 mr-2 ml-auto">Show {props.toggleTxt}</label>
                    <Switch onChange={onSwitch} />
                    <div>
                        <OutlinedButton
                            svgFile={plus}
                            title="Add New User"
                            clickEvent={(e) => {
                                props.setUserFToogle(true)
                            }}
                            className="add-user-btn"
                        />
                    </div>
                    {
                        props.isExpert &&
                        <div className="pointer reload-btn" onClick={() => props.export()}>
                            <img className="ml-3 mr-2" src={require('../../assets/images/export.svg').default} alt="" />
                            <label className="uppercase m-0">Export</label>
                        </div>
                    }
                </div>
            </div>

            <div className='users-table'>
                {data.length === 0 && props.loadingData ?
                    <Skeleton active paragraph={{ rows: 10, width: '100%' }} />
                    : data.length > 0 ?
                        <ReactTable
                            data={data}
                            columns={columns}
                            expanded={aUserExpanded}
                            pageSize={data.length}
                            getTrProps={(state, rowInfo, column, instance) => {
                                return {
                                    onClick: e => {
                                        if (e.target.name == "edit-action") {
                                            const expandedT = { ...aUserExpanded };
                                            expandedT[rowInfo.viewIndex] = aUserExpanded[rowInfo.viewIndex] ? false : true;
                                            setAUserExpanded({ [rowInfo.viewIndex]: true });
                                        }
                                    },
                                    style: {
                                        animation: rowInfo?.viewIndex?.toString() === Object.keys(aUserExpanded)[0] ? 'fadeOut 0.3s' : 'fadeIn 0.3s ease-in-out',
                                        opacity: rowInfo?.viewIndex?.toString() === Object.keys(aUserExpanded)[0] ? 0 : 1,
                                        height: rowInfo?.viewIndex?.toString() === Object.keys(aUserExpanded)[0] ? 0 : 'auto',
                                    }
                                };
                            }}
                            SubComponent={row => {
                                return (
                                    <div
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.5 }}
                                        className="content subcomponent" id={`rowId_${row.original.id}`}>
                                        <div className='edit-wrap item d-flex flex-row align-items-center'>
                                            <div className='text-uppercase user_avatar'>
                                                {displayShortName(row.original)}
                                            </div>
                                            <div>
                                                <div>
                                                    <input
                                                        type="text"
                                                        name="username"
                                                        id="username"
                                                        autoComplete="username"
                                                        value={row.original.firstname + ' ' + row.original.lastname}
                                                        onChange={(e) => {
                                                            let tempUser = data.map(item => {
                                                                if (item.id == row.original.id) {
                                                                    item.firstname = (e.target.value).split(' ')[0]
                                                                    item.lastname = (e.target.value).split(' ')[1]
                                                                }

                                                                return item
                                                            })

                                                            setData(tempUser)
                                                            props.updateUserInOrg(row.original)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='edit-wrap item'>
                                            <div>
                                                <input
                                                    type="text"
                                                    name="useremail"
                                                    id="useremail"
                                                    autoComplete="useremail"
                                                    value={row.original.email}
                                                    onChange={(e) => {
                                                        let tempUser = data.map(item => {
                                                            if (item.id == row.original.id) {
                                                                item.email = e.target.value
                                                            }

                                                            return item
                                                        })

                                                        setData(tempUser)
                                                        props.updateUserInOrg(row.original)
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* ✅ Role dropdown (Edit) */}
                                        <div className='col-12 col-md-2 edit-wrap item'>
                                            <AutoSelectOnTab
                                                placeholder="Select role"
                                                size="large"
                                                style={{ width: '100%' }}
                                                value={row.original?.role_id}
                                                options={roleOptions}
                                                onChange={(val) => {
                                                    let tempUser = data.map(item => {
                                                        if (item.id === row.original.id) {
                                                            item.role_id = val
                                                        }
                                                        return item
                                                    })

                                                    setData(tempUser)

                                                    props.updateUserInOrg({
                                                        ...row.original,
                                                        role_id: val
                                                    })
                                                }}
                                            />
                                        </div>

                                        <div className="item">
                                            <div className='d-flex'>
                                                <Switch onChange={(checked) => onUserActive(checked, row.original)} checked={row.original.is_active ? true : false} />
                                                <span className="table-toggle-text my-0 ml-2">{row.original.is_active ? 'Active' : 'Inactive'}</span>
                                            </div>
                                        </div>

                                        <div className="col-2 item d-flex flex-row gap-3 ">
                                            <OutlinedButton title='Send Password Reset' className='resetpass' clickEvent={() => props.resetUserPassword(row.original.id)} />
                                            <img alt="" className='pointer' src={require('../../assets/images/production_board/modal-close.svg').default} onClick={() => setAUserExpanded({})} />
                                        </div>
                                    </div>
                                );
                            }}
                        />
                        : null
                }

                {
                    data.length > 0 && Math.ceil(data.total / DEFAULT_PAGE_SIZE) > 1 &&
                    <Space className="custom-table-pos d-flex flex-row justify-content-around py-2">
                        <OutlinedButton
                            title="First"
                            className="uppercase"
                            disabled={currentPage == 1 ? true : false}
                            clickEvent={(e) => onPagiChange(1)}
                        />
                        <Pagination current={currentPage} defaultPageSize={DEFAULT_PAGE_SIZE} total={data.total} onChange={onPagiChange} showSizeChanger={false} />
                        <OutlinedButton
                            title="Last"
                            className="uppercase"
                            disabled={currentPage == Math.ceil(data.total / DEFAULT_PAGE_SIZE) ? true : false}
                            clickEvent={(e) => onPagiChange( Math.ceil(data.total / DEFAULT_PAGE_SIZE) )}
                        />
                    </Space>
                }

                {
                    props.userFToogle &&
                    <>
                        {
                            data.length == 0 &&
                            <div className="new-user_row d-flex flex-row content profile_temp-title">
                                <div className='edit-wrap title my-2'>
                                    Name
                                </div>
                                <div className='edit-wrap title my-2'>
                                    Email
                                </div>
                                <div className='edit-wrap m-auto title my-2'>
                                    Role
                                </div>
                                <div className='edit-wrap m-auto title my-2'>
                                    Status
                                </div>
                                <div className='edit-wrap title my-2'>
                                    Action
                                </div>
                            </div>
                        }

                        <div className="new-user_row d-flex flex-row content">
                            <div className='edit-wrap'>
                                <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    autoComplete="name"
                                    vaule={props.newUser.name}
                                    onChange={handleNewUser}
                                />
                            </div>

                            <div className='edit-wrap'>
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    vaule={props.newUser.email}
                                    onChange={handleNewUser}
                                />
                            </div>

                            {/* ✅ Role dropdown (Create) */}
                            <div className='edit-wrap m-auto'>
                                <AutoSelectOnTab
                                    placeholder="Select role"
                                    value={props.newUser?.role_id}
                                    size="large"
                                    style={{ width: '100%' }}
                                    options={roleOptions.map((r) => ({
                                        label: r.label,
                                        value: r.value
                                    }))}
                                    onChange={(val) => {
                                        props.setNewUser({
                                            ...props.newUser,
                                            role_id: val
                                        })
                                    }}
                                />
                            </div>

                            <div className='edit-wrap m-auto mobile-status'>
                                <Switch
                                    name="is_active"
                                    id="is_active"
                                    onChange={(checked) => {
                                        props.setNewUser({
                                            ...props.newUser,
                                            ['is_active']: checked
                                        })
                                    }}
                                    defaultChecked={true}
                                    value={props.newUser.is_active}
                                />
                                <span className="table-toggle-text my-0 ml-2">{props.newUser.is_active ? 'Active' : 'Inactive'}</span>
                            </div>

                            <div className='edit-wrap'>
                                {props.saveLoading ?
                                    <Spin className='mt-2' />
                                    :
                                    <FilledBrightButton
                                        type="button"
                                        title="Save"
                                        clickEvent={() => props.addNewUserInOrg()}
                                        className="mt-2"
                                    />
                                }
                            </div>
                        </div>
                    </>
                }

                <Can permission={PERMISSIONS.SETTINGS_USER_CREATE}>
                    <div className="px-3">
                        <OutlinedButton
                            svgFile={plus}
                            title="Add New User"
                            clickEvent={(e) => {
                                props.setUserFToogle(true)
                            }}
                            className="mt-2"
                        />
                    </div>
                </Can>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        types: state.UserReducer.user_types.data,
        isSuccessOrgUserUpdate: state.UserReducer.isSuccessOrgUserUpdate,
        updatedUser: state.UserReducer.updatedUser,
        roles: state.UserReducer.user_roles.data
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getUserTypes: () => dispatch(getUserTypes()),
        getUserRoles: () => dispatch(getUserRoles()),
        updateUserInOrg: (data) => dispatch(updateUserInOrg(data)),
        resetUserPassword: (userId) => dispatch(resetUserPassword(userId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpandableTable)
